import React from "react";
import Layout from "../components/Layout";
import Seo from "../components/Seo";
import { PageRendererProps, Link } from "gatsby";
import WavesBottom from "../components/WavesBottom";

const PrivacyPolicyPage = ({ location }: PageRendererProps) => {
  return (
    <Layout location={location}>
      <Seo title="Datenschutzerklärung" />

      <section className="py-20 bg-white">
        <div className="container max-w-5xl p-6 m-8 mx-auto">
          <h2 className="w-full my-8 font-bold leading-tight text-center text-gray-800 sm:text-3xl lg:text-5xl">
            Datenschutzerklärung
          </h2>
          <p className="mb-8 text-gray-600">
            Diese Datenschutzerklärung klärt Sie über die Art, den Umfang und
            Zweck der Verarbeitung von personenbezogenen Daten (nachfolgend kurz
            „Daten“) innerhalb unseres Onlineangebotes und der mit ihm
            verbundenen Webseiten, Funktionen und Inhalte sowie externen
            Onlinepräsenzen, wie z.B. unser Social Media Profile auf
            (nachfolgend gemeinsam bezeichnet als „Onlineangebot“). Im Hinblick
            auf die verwendeten Begrifflichkeiten, wie z.B. „Verarbeitung“ oder
            „Verantwortlicher“ verweisen wir auf die Definitionen im Art. 4 der
            Datenschutzgrundverordnung (DSGVO).
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Verantwortlicher
          </h3>
          <p className="mb-8 text-gray-600">
            getsby GmbH,
            <br />
            Maria Jacobi Gasse 1, Media Quarter Marx 3.2, A-1030 Wien
            <br />
            UID: ATU75803025
            <br />
            FN: 538605t des Firmenbuches des HG Wien
            <br />
            Email:{" "}
            <a className="text-yellow-500" href="mailto:office@gets.by">
              office@gets.by
            </a>
            <br />
            <Link className="text-yellow-500" to="/imprint">
              http://www.gets.by/impressum/
            </Link>
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Arten der verarbeiteten Daten:
          </h3>
          <ul className="mb-8 text-gray-600 list-disc list-outside">
            <li>Bestandsdaten (z.B., Namen, Adressen).</li>
            <li>Kontaktdaten (z.B., E-Mail, Telefonnummern).</li>
            <li>Inhaltsdaten (z.B., Texteingaben, Fotografien, Videos).</li>
            <li>
              Nutzungsdaten (z.B., besuchte Webseiten, Interesse an Inhalten,
              Zugriffszeiten).
            </li>
            <li>
              Meta-/Kommunikationsdaten (z.B., Geräte-Informationen,
              IP-Adressen).
            </li>
          </ul>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Kategorien betroffener Personen
          </h3>
          <p className="mb-8 text-gray-600">
            Besucher und Nutzer des Onlineangebotes (Nachfolgend bezeichnen wir
            die betroffenen Personen zusammenfassend auch als „Nutzer“).
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Zweck der Verarbeitung
          </h3>
          <ul className="mb-8 text-gray-600 list-disc list-outside">
            <li>
              Zurverfügungstellung des Onlineangebotes, seiner Funktionen und
              Inhalte.
            </li>
            <li>
              Beantwortung von Kontaktanfragen und Kommunikation mit Nutzern.
            </li>
            <li>Sicherheitsmaßnahmen.</li>
            <li>Reichweitenmessung/Marketing</li>
          </ul>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Verwendete Begrifflichkeiten
          </h3>
          <p className="mb-8 text-gray-600">
            „Personenbezogene Daten“ sind alle Informationen, die sich auf eine
            identifizierte oder identifizierbare natürliche Person (im Folgenden
            „betroffene Person“) beziehen; als identifizierbar wird eine
            natürliche Person angesehen, die direkt oder indirekt, insbesondere
            mittels Zuordnung zu einer Kennung wie einem Namen, zu einer
            Kennnummer, zu Standortdaten, zu einer Online-Kennung (z.B. Cookie)
            oder zu einem oder mehreren besonderen Merkmalen identifiziert
            werden kann, die Ausdruck der physischen, physiologischen,
            genetischen, psychischen, wirtschaftlichen, kulturellen oder
            sozialen Identität dieser natürlichen Person sind.
          </p>
          <p className="mb-8 text-gray-600">
            „Verarbeitung“ ist jeder mit oder ohne Hilfe automatisierter
            Verfahren ausgeführte Vorgang oder jede solche Vorgangsreihe im
            Zusammenhang mit personenbezogenen Daten. Der Begriff reicht weit
            und umfasst praktisch jeden Umgang mit Daten.
          </p>
          <p className="mb-8 text-gray-600">
            „Pseudonymisierung“ die Verarbeitung personenbezogener Daten in
            einer Weise, dass die personenbezogenen Daten ohne Hinzuziehung
            zusätzlicher Informationen nicht mehr einer spezifischen betroffenen
            Person zugeordnet werden können, sofern diese zusätzlichen
            Informationen gesondert aufbewahrt werden und technischen und
            organisatorischen Maßnahmen unterliegen, die gewährleisten, dass die
            personenbezogenen Daten nicht einer identifizierten oder
            identifizierbaren natürlichen Person zugewiesen werden.
          </p>
          <p className="mb-8 text-gray-600">
            „Profiling“ jede Art der automatisierten Verarbeitung
            personenbezogener Daten, die darin besteht, dass diese
            personenbezogenen Daten verwendet werden, um bestimmte persönliche
            Aspekte, die sich auf eine natürliche Person beziehen, zu bewerten,
            insbesondere um Aspekte bezüglich Arbeitsleistung, wirtschaftliche
            Lage, Gesundheit, persönliche Vorlieben, Interessen,
            Zuverlässigkeit, Verhalten, Aufenthaltsort oder Ortswechsel dieser
            natürlichen Person zu analysieren oder vorherzusagen.
          </p>
          <p className="mb-8 text-gray-600">
            Als „Verantwortlicher“ wird die natürliche oder juristische Person,
            Behörde, Einrichtung oder andere Stelle, die allein oder gemeinsam
            mit anderen über die Zwecke und Mittel der Verarbeitung von
            personenbezogenen Daten entscheidet, bezeichnet.
          </p>
          <p className="mb-8 text-gray-600">
            „Auftragsverarbeiter“ eine natürliche oder juristische Person,
            Behörde, Einrichtung oder andere Stelle, die personenbezogene Daten
            im Auftrag des Verantwortlichen verarbeitet.
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Maßgebliche Rechtsgrundlagen
          </h3>
          <p className="mb-8 text-gray-600">
            Nach Maßgabe des Art. 13 DSGVO teilen wir Ihnen die Rechtsgrundlagen
            unserer Datenverarbeitungen mit. Sofern die Rechtsgrundlage in der
            Datenschutzerklärung nicht genannt wird, gilt Folgendes: Die
            Rechtsgrundlage für die Einholung von Einwilligungen ist Art. 6 Abs.
            1 lit. a und Art. 7 DSGVO, die Rechtsgrundlage für die Verarbeitung
            zur Erfüllung unserer Leistungen und Durchführung vertraglicher
            Maßnahmen sowie Beantwortung von Anfragen ist Art. 6 Abs. 1 lit. b
            DSGVO, die Rechtsgrundlage für die Verarbeitung zur Erfüllung
            unserer rechtlichen Verpflichtungen ist Art. 6 Abs. 1 lit. c DSGVO,
            und die Rechtsgrundlage für die Verarbeitung zur Wahrung unserer
            berechtigten Interessen ist Art. 6 Abs. 1 lit. f DSGVO. Für den
            Fall, dass lebenswichtige Interessen der betroffenen Person oder
            einer anderen natürlichen Person eine Verarbeitung personenbezogener
            Daten erforderlich machen, dient Art. 6 Abs. 1 lit. d DSGVO als
            Rechtsgrundlage.
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Sicherheitsmaßnahmen
          </h3>
          <p className="mb-8 text-gray-600">
            Wir treffen nach Maßgabe des Art. 32 DSGVO unter Berücksichtigung
            des Stands der Technik, der Implementierungskosten und der Art, des
            Umfangs, der Umstände und der Zwecke der Verarbeitung sowie der
            unterschiedlichen Eintrittswahrscheinlichkeit und Schwere des
            Risikos für die Rechte und Freiheiten natürlicher Personen,
            geeignete technische und organisatorische Maßnahmen, um ein dem
            Risiko angemessenes Schutzniveau zu gewährleisten.
          </p>
          <p className="mb-8 text-gray-600">
            Zu den Maßnahmen gehören insbesondere die Sicherung der
            Vertraulichkeit, Integrität und Verfügbarkeit von Daten durch
            Kontrolle des physischen Zugangs zu den Daten, als auch des sie
            betreffenden Zugriffs, der Eingabe, Weitergabe, der Sicherung der
            Verfügbarkeit und ihrer Trennung. Des Weiteren haben wir Verfahren
            eingerichtet, die eine Wahrnehmung von Betroffenenrechten, Löschung
            von Daten und Reaktion auf Gefährdung der Daten gewährleisten.
            Ferner berücksichtigen wir den Schutz personenbezogener Daten
            bereits bei der Entwicklung, bzw. Auswahl von Hardware, Software
            sowie Verfahren, entsprechend dem Prinzip des Datenschutzes durch
            Technikgestaltung und durch datenschutzfreundliche Voreinstellungen
            (Art. 25 DSGVO).
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Zusammenarbeit mit Auftragsverarbeitern und Dritten
          </h3>
          <p className="mb-8 text-gray-600">
            Sofern wir im Rahmen unserer Verarbeitung Daten gegenüber anderen
            Personen und Unternehmen (Auftragsverarbeitern oder Dritten)
            offenbaren, sie an diese übermitteln oder ihnen sonst Zugriff auf
            die Daten gewähren, erfolgt dies nur auf Grundlage einer
            gesetzlichen Erlaubnis (z.B. wenn eine Übermittlung der Daten an
            Dritte, wie an Zahlungsdienstleister, gem. Art. 6 Abs. 1 lit. b
            DSGVO zur Vertragserfüllung erforderlich ist), Sie eingewilligt
            haben, eine rechtliche Verpflichtung dies vorsieht oder auf
            Grundlage unserer berechtigten Interessen (z.B. beim Einsatz von
            Beauftragten, Webhostern, etc.).
          </p>
          <p className="mb-8 text-gray-600">
            Sofern wir Dritte mit der Verarbeitung von Daten auf Grundlage eines
            sog. „Auftragsverarbeitungsvertrages“ beauftragen, geschieht dies
            auf Grundlage des Art. 28 DSGVO.
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Übermittlungen in Drittländer
          </h3>
          <p className="mb-8 text-gray-600">
            Sofern wir Daten in einem Drittland (d.h. außerhalb der Europäischen
            Union (EU) oder des Europäischen Wirtschaftsraums (EWR)) verarbeiten
            oder dies im Rahmen der Inanspruchnahme von Diensten Dritter oder
            Offenlegung, bzw. Übermittlung von Daten an Dritte geschieht,
            erfolgt dies nur, wenn es zur Erfüllung unserer (vor)vertraglichen
            Pflichten, auf Grundlage Ihrer Einwilligung, aufgrund einer
            rechtlichen Verpflichtung oder auf Grundlage unserer berechtigten
            Interessen geschieht. Vorbehaltlich gesetzlicher oder vertraglicher
            Erlaubnisse, verarbeiten oder lassen wir die Daten in einem
            Drittland nur beim Vorliegen der besonderen Voraussetzungen der Art.
            44 ff. DSGVO verarbeiten. D.h. die Verarbeitung erfolgt z.B. auf
            Grundlage besonderer Garantien, wie der offiziell anerkannten
            Feststellung eines der EU entsprechenden Datenschutzniveaus (z.B.
            für die USA durch das „Privacy Shield“) oder Beachtung offiziell
            anerkannter spezieller vertraglicher Verpflichtungen (so genannte
            „Standardvertragsklauseln“).
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Rechte der betroffenen Personen
          </h3>
          <p className="mb-8 text-gray-600">
            Sie haben das Recht, eine Bestätigung darüber zu verlangen, ob
            betreffende Daten verarbeitet werden und auf Auskunft über diese
            Daten sowie auf weitere Informationen und Kopie der Daten
            entsprechend Art. 15 DSGVO.
          </p>
          <p className="mb-8 text-gray-600">
            Sie haben entsprechend. Art. 16 DSGVO das Recht, die
            Vervollständigung der Sie betreffenden Daten oder die Berichtigung
            der Sie betreffenden unrichtigen Daten zu verlangen.
          </p>
          <p className="mb-8 text-gray-600">
            Sie haben nach Maßgabe des Art. 17 DSGVO das Recht zu verlangen,
            dass betreffende Daten unverzüglich gelöscht werden, bzw. alternativ
            nach Maßgabe des Art. 18 DSGVO eine Einschränkung der Verarbeitung
            der Daten zu verlangen.
          </p>
          <p className="mb-8 text-gray-600">
            Sie haben das Recht zu verlangen, dass die Sie betreffenden Daten,
            die Sie uns bereitgestellt haben nach Maßgabe des Art. 20 DSGVO zu
            erhalten und deren Übermittlung an andere Verantwortliche zu
            fordern.
          </p>
          <p className="mb-8 text-gray-600">
            Sie haben ferner gem. Art. 77 DSGVO das Recht, eine Beschwerde bei
            der zuständigen Aufsichtsbehörde einzureichen.
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Widerrufsrecht
          </h3>
          <p className="mb-8 text-gray-600">
            Sie haben das Recht, erteilte Einwilligungen gem. Art. 7 Abs. 3
            DSGVO mit Wirkung für die Zukunft zu widerrufen
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Widerspruchsrecht
          </h3>
          <p className="mb-8 text-gray-600">
            Sie können der künftigen Verarbeitung der Sie betreffenden Daten
            nach Maßgabe des Art. 21 DSGVO jederzeit widersprechen. Der
            Widerspruch kann insbesondere gegen die Verarbeitung für Zwecke der
            Direktwerbung erfolgen.
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Cookies und Widerspruchsrecht bei Direktwerbung
          </h3>
          <p className="mb-8 text-gray-600">
            Als „Cookies“ werden kleine Dateien bezeichnet, die auf Rechnern der
            Nutzer gespeichert werden. Innerhalb der Cookies können
            unterschiedliche Angaben gespeichert werden. Ein Cookie dient primär
            dazu, die Angaben zu einem Nutzer (bzw. dem Gerät auf dem das Cookie
            gespeichert ist) während oder auch nach seinem Besuch innerhalb
            eines Onlineangebotes zu speichern. Als temporäre Cookies, bzw.
            „Session-Cookies“ oder „transiente Cookies“, werden Cookies
            bezeichnet, die gelöscht werden, nachdem ein Nutzer ein
            Onlineangebot verlässt und seinen Browser schließt. In einem solchen
            Cookie kann z.B. der Inhalt eines Warenkorbs in einem Onlineshop
            oder ein Login-Status gespeichert werden. Als „permanent“ oder
            „persistent“ werden Cookies bezeichnet, die auch nach dem Schließen
            des Browsers gespeichert bleiben. So kann z.B. der Login-Status
            gespeichert werden, wenn die Nutzer diese nach mehreren Tagen
            aufsuchen. Ebenso können in einem solchen Cookie die Interessen der
            Nutzer gespeichert werden, die für Reichweitenmessung oder
            Marketingzwecke verwendet werden. Als „Third-Party-Cookie“ werden
            Cookies bezeichnet, die von anderen Anbietern als dem
            Verantwortlichen, der das Onlineangebot betreibt, angeboten werden
            (andernfalls, wenn es nur dessen Cookies sind spricht man von
            „First-Party Cookies“).
          </p>
          <p className="mb-8 text-gray-600">
            Wir können temporäre und permanente Cookies einsetzen und klären
            hierüber im Rahmen unserer Datenschutzerklärung auf.
          </p>
          <p className="mb-8 text-gray-600">
            Falls die Nutzer nicht möchten, dass Cookies auf ihrem Rechner
            gespeichert werden, werden sie gebeten die entsprechende Option in
            den Systemeinstellungen ihres Browsers zu deaktivieren. Gespeicherte
            Cookies können in den Systemeinstellungen des Browsers gelöscht
            werden. Der Ausschluss von Cookies kann zu Funktionseinschränkungen
            dieses Onlineangebotes führen.
          </p>
          <p className="mb-8 text-gray-600">
            Ein genereller Widerspruch gegen den Einsatz der zu Zwecken des
            Onlinemarketing eingesetzten Cookies kann bei einer Vielzahl der
            Dienste, vor allem im Fall des Trackings, über die US-amerikanische
            Seite{" "}
            <a
              className="text-yellow-500"
              href="http://www.aboutads.info/choices/"
            >
              http://www.aboutads.info/choices/
            </a>{" "}
            oder die EU-Seite{" "}
            <a
              className="text-yellow-500"
              href="http://www.youronlinechoices.com/"
            >
              http://www.youronlinechoices.com/
            </a>{" "}
            erklärt werden. Des Weiteren kann die Speicherung von Cookies
            mittels deren Abschaltung in den Einstellungen des Browsers erreicht
            werden. Bitte beachten Sie, dass dann gegebenenfalls nicht alle
            Funktionen dieses Onlineangebotes genutzt werden können.
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Löschung von Daten
          </h3>
          <p className="mb-8 text-gray-600">
            Die von uns verarbeiteten Daten werden nach Maßgabe der Art. 17 und
            18 DSGVO gelöscht oder in ihrer Verarbeitung eingeschränkt. Sofern
            nicht im Rahmen dieser Datenschutzerklärung ausdrücklich angegeben,
            werden die bei uns gespeicherten Daten gelöscht, sobald sie für ihre
            Zweckbestimmung nicht mehr erforderlich sind und der Löschung keine
            gesetzlichen Aufbewahrungspflichten entgegenstehen. Sofern die Daten
            nicht gelöscht werden, weil sie für andere und gesetzlich zulässige
            Zwecke erforderlich sind, wird deren Verarbeitung eingeschränkt.
            D.h. die Daten werden gesperrt und nicht für andere Zwecke
            verarbeitet. Das gilt z.B. für Daten, die aus handels- oder
            steuerrechtlichen Gründen aufbewahrt werden müssen.
          </p>
          <p className="mb-8 text-gray-600">
            Nach gesetzlichen Vorgaben in Deutschland, erfolgt die Aufbewahrung
            insbesondere für 10 Jahre gemäß §§ 147 Abs. 1 AO, 257 Abs. 1 Nr. 1
            und 4, Abs. 4 HGB (Bücher, Aufzeichnungen, Lageberichte,
            Buchungsbelege, Handelsbücher, für Besteuerung relevanter
            Unterlagen, etc.) und 6 Jahre gemäß § 257 Abs. 1 Nr. 2 und 3, Abs. 4
            HGB (Handelsbriefe).
          </p>
          <p className="mb-8 text-gray-600">
            Nach gesetzlichen Vorgaben in Österreich erfolgt die Aufbewahrung
            insbesondere für 7 J gemäß § 132 Abs. 1 BAO (Buchhaltungsunterlagen,
            Belege/Rechnungen, Konten, Belege, Geschäftspapiere, Aufstellung der
            Einnahmen und Ausgaben, etc.), für 22 Jahre im Zusammenhang mit
            Grundstücken und für 10 Jahre bei Unterlagen im Zusammenhang mit
            elektronisch erbrachten Leistungen, Telekommunikations-, Rundfunk-
            und Fernsehleistungen, die an Nichtunternehmer in EU-Mitgliedstaaten
            erbracht werden und für die der Mini-One-Stop-Shop (MOSS) in
            Anspruch genommen wird.
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Geschäftsbezogene Verarbeitung
          </h3>
          <p className="mb-8 text-gray-600">Zusätzlich verarbeiten wir</p>
          <ul className="mb-8 text-gray-600 list-disc list-outside">
            <li>
              Vertragsdaten (z.B., Vertragsgegenstand, Laufzeit,
              Kundenkategorie).
            </li>
            <li>Zahlungsdaten (z.B., Bankverbindung, Zahlungshistorie)</li>
          </ul>
          <p className="mb-8 text-gray-600">
            von unseren Kunden, Interessenten und Geschäftspartner zwecks
            Erbringung vertraglicher Leistungen, Service und Kundenpflege,
            Marketing, Werbung und Marktforschung.
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Bestellabwicklung im Onlineshop und Kundenkonto
          </h3>
          <p className="mb-8 text-gray-600">
            Wir verarbeiten die Daten unserer Kunden im Rahmen der
            Bestellvorgänge in unserem Onlineshop, um ihnen die Auswahl und die
            Bestellung der gewählten Produkte und Leistungen, sowie deren
            Bezahlung und Zustellung, bzw. Ausführung zu ermöglichen.
          </p>
          <p className="mb-8 text-gray-600">
            Zu den verarbeiteten Daten gehören Bestandsdaten,
            Kommunikationsdaten, Vertragsdaten, Zahlungsdaten und zu den von der
            Verarbeitung betroffenen Personen gehören unsere Kunden,
            Interessenten und sonstige Geschäftspartner. Die Verarbeitung
            erfolgt zum Zweck der Erbringung von Vertragsleistungen im Rahmen
            des Betriebs eines Onlineshops, Abrechnung, Auslieferung und der
            Kundenservices. Hierbei setzen wir Session Cookies für die
            Speicherung des Warenkorb-Inhalts und permanente Cookies für die
            Speicherung des Login-Status ein.
          </p>
          <p className="mb-8 text-gray-600">
            Die Verarbeitung erfolgt auf Grundlage des Art. 6 Abs. 1 lit. b
            (Durchführung Bestellvorgänge) und c (Gesetzlich erforderliche
            Archivierung) DSGVO. Dabei sind die als erforderlich
            gekennzeichneten Angaben zur Begründung und Erfüllung des Vertrages
            erforderlich. Die Daten offenbaren wir gegenüber Dritten nur im
            Rahmen der Auslieferung, Zahlung oder im Rahmen der gesetzlichen
            Erlaubnisse und Pflichten gegenüber Rechtsberatern und Behörden. Die
            Daten werden in Drittländern nur dann verarbeitet, wenn dies zur
            Vertragserfüllung erforderlich ist (z.B. auf Kundenwunsch bei
            Auslieferung oder Zahlung).
          </p>
          <p className="mb-8 text-gray-600">
            Nutzer können optional ein Nutzerkonto anlegen, indem sie
            insbesondere ihre Bestellungen einsehen können. Im Rahmen der
            Registrierung, werden die erforderlichen Pflichtangaben den Nutzern
            mitgeteilt. Die Nutzerkonten sind nicht öffentlich und können von
            Suchmaschinen nicht indexiert werden. Wenn Nutzer ihr Nutzerkonto
            gekündigt haben, werden deren Daten im Hinblick auf das Nutzerkonto
            gelöscht, vorbehaltlich deren Aufbewahrung ist aus handels- oder
            steuerrechtlichen Gründen entspr. Art. 6 Abs. 1 lit. c DSGVO
            notwendig. Angaben im Kundenkonto verbleiben bis zu dessen Löschung
            mit anschließender Archivierung im Fall einer rechtlichen
            Verpflichtung. Es obliegt den Nutzern, ihre Daten bei erfolgter
            Kündigung vor dem Vertragsende zu sichern.
          </p>
          <p className="mb-8 text-gray-600">
            Im Rahmen der Registrierung und erneuter Anmeldungen sowie
            Inanspruchnahme unserer Onlinedienste, speichern wir die IP-Adresse
            und den Zeitpunkt der jeweiligen Nutzerhandlung. Die Speicherung
            erfolgt auf Grundlage unserer berechtigten Interessen, als auch der
            Nutzer an Schutz vor Missbrauch und sonstiger unbefugter Nutzung.
            Eine Weitergabe dieser Daten an Dritte erfolgt grundsätzlich nicht,
            außer sie ist zur Verfolgung unserer Ansprüche erforderlich oder es
            besteht hierzu eine gesetzliche Verpflichtung gem. Art. 6 Abs. 1
            lit. c DSGVO.
          </p>
          <p className="mb-8 text-gray-600">
            Die Löschung erfolgt nach Ablauf gesetzlicher Gewährleistungs- und
            vergleichbarer Pflichten, die Erforderlichkeit der Aufbewahrung der
            Daten wird alle drei Jahre überprüft; im Fall der gesetzlichen
            Archivierungspflichten erfolgt die Löschung nach deren Ablauf (Ende
            handelsrechtlicher (6 Jahre) und steuerrechtlicher (10 Jahre)
            Aufbewahrungspflicht).
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Vertragliche Leistungen
          </h3>
          <p className="mb-8 text-gray-600">
            Wir verarbeiten die Daten unserer Vertragspartner und Interessenten
            sowie anderer Auftraggeber, Kunden, Mandanten, Klienten oder
            Vertragspartner (einheitlich bezeichnet als „Vertragspartner“)
            entsprechend Art. 6 Abs. 1 lit. b. DSGVO, um ihnen gegenüber unsere
            vertraglichen oder vorvertraglichen Leistungen zu erbringen. Die
            hierbei verarbeiteten Daten, die Art, der Umfang und der Zweck und
            die Erforderlichkeit ihrer Verarbeitung, bestimmen sich nach dem
            zugrundeliegenden Vertragsverhältnis.
          </p>
          <p className="mb-8 text-gray-600">
            Zu den verarbeiteten Daten gehören die Stammdaten unserer
            Vertragspartner (z.B., Namen und Adressen), Kontaktdaten (z.B.
            E-Mailadressen und Telefonnummern) sowie Vertragsdaten (z.B., in
            Anspruch genommene Leistungen, Vertragsinhalte, vertragliche
            Kommunikation, Namen von Kontaktpersonen) und Zahlungsdaten (z.B.,
            Bankverbindungen, Zahlungshistorie).
          </p>
          <p className="mb-8 text-gray-600">
            Besondere Kategorien personenbezogener Daten verarbeiten wir
            grundsätzlich nicht, außer wenn diese Bestandteile einer
            beauftragten oder vertragsgemäßen Verarbeitung sind.
          </p>
          <p className="mb-8 text-gray-600">
            Wir verarbeiten Daten, die zur Begründung und Erfüllung der
            vertraglichen Leistungen erforderlich sind und weisen auf die
            Erforderlichkeit ihrer Angabe, sofern diese für die Vertragspartner
            nicht evident ist, hin. Eine Offenlegung an externe Personen oder
            Unternehmen erfolgt nur, wenn sie im Rahmen eines Vertrags
            erforderlich ist. Bei der Verarbeitung der uns im Rahmen eines
            Auftrags überlassenen Daten, handeln wir entsprechend den Weisungen
            der Auftraggeber sowie der gesetzlichen Vorgaben.
          </p>
          <p className="mb-8 text-gray-600">
            Im Rahmen der Inanspruchnahme unserer Onlinedienste, können wir die
            IP-Adresse und den Zeitpunkt der jeweiligen Nutzerhandlung
            speichern. Die Speicherung erfolgt auf Grundlage unserer
            berechtigten Interessen, als auch der Interessen der Nutzer am
            Schutz vor Missbrauch und sonstiger unbefugter Nutzung. Eine
            Weitergabe dieser Daten an Dritte erfolgt grundsätzlich nicht, außer
            sie ist zur Verfolgung unserer Ansprüche gem. Art. 6 Abs. 1 lit. f.
            DSGVO erforderlich oder es besteht hierzu eine gesetzliche
            Verpflichtung gem. Art. 6 Abs. 1 lit. c. DSGVO.
          </p>
          <p className="mb-8 text-gray-600">
            Die Löschung der Daten erfolgt, wenn die Daten zur Erfüllung
            vertraglicher oder gesetzlicher Fürsorgepflichten sowie für den
            Umgang mit etwaigen Gewährleistungs- und vergleichbaren Pflichten
            nicht mehr erforderlich sind, wobei die Erforderlichkeit der
            Aufbewahrung der Daten alle drei Jahre überprüft wird; im Übrigen
            gelten die gesetzlichen Aufbewahrungspflichten.
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Externe Zahlungsdienstleister
          </h3>
          <p className="mb-8 text-gray-600">
            Wir setzen externe Zahlungsdienstleister ein, über deren Plattformen
            die Nutzer und wir Zahlungstransaktionen vornehmen können (z.B.,
            jeweils mit Link zur Datenschutzerklärung, Paypal
            (https://www.paypal.com/de/webapps/mpp/ua/privacy-full), Klarna
            (https://www.klarna.com/de/datenschutz/), Skrill
            (https://www.skrill.com/de/fusszeile/datenschutzrichtlinie/),
            Giropay (https://www.giropay.de/rechtliches/datenschutz-agb/), Visa
            (https://www.visa.de/datenschutz), Mastercard
            (https://www.mastercard.de/de-de/datenschutz.html), American Express
            (https://www.americanexpress.com/de/content/privacy-policy-statement.html)
          </p>
          <p className="mb-8 text-gray-600">
            Im Rahmen der Erfüllung von&nbsp;Verträgen setzen wir die
            Zahlungsdienstleister auf Grundlage des Art. 6 Abs. 1 lit. b. DSGVO
            ein. Im Übrigen setzen wir externe&nbsp;Zahlungsdienstleister auf
            Grundlage unserer berechtigten Interessen gem. Art. 6 Abs. 1 lit. f.
            DSGVO ein, um unseren Nutzern effektive und sichere
            Zahlungsmöglichkeit zu bieten.
          </p>
          <p className="mb-8 text-gray-600">
            Zu den, durch die Zahlungsdienstleister verarbeiteten Daten gehören
            Bestandsdaten, wie z.B. der Name und die Adresse, Bankdaten, wie
            z.B. Kontonummern oder Kreditkartennummern, Passwörter, TANs und
            Prüfsummen sowie die Vertrags-, Summen und empfängerbezogenen
            Angaben. Die Angaben sind erforderlich, um die Transaktionen
            durchzuführen. Die eingegebenen Daten werden jedoch nur durch die
            Zahlungsdienstleister verarbeitet und bei diesen gespeichert. D.h.
            wir erhalten keine konto- oder kreditkartenbezogenen Informationen,
            sondern lediglich Informationen mit Bestätigung oder
            Negativbeauskunftung der Zahlung.&nbsp;Unter Umständen werden die
            Daten seitens der Zahlungsdienstleister an Wirtschaftsauskunfteien
            übermittelt. Diese Übermittlung bezweckt die Identitäts- und
            Bonitätsprüfung. Hierzu verweisen wir auf die AGB und
            Datenschutzhinweise der&nbsp;Zahlungsdienstleister.
          </p>
          <p className="mb-8 text-gray-600">
            Für die Zahlungsgeschäfte gelten die Geschäftsbedingungen und die
            Datenschutzhinweise der jeweiligen Zahlungsdienstleister, welche
            innerhalb der jeweiligen Webseiten, bzw. Transaktionsapplikationen
            abrufbar sind. Wir verweisen auf diese ebenfalls zwecks weiterer
            Informationen und Geltendmachung von Widerrufs-, Auskunfts- und
            anderen Betroffenenrechten.
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Administration, Finanzbuchhaltung, Büroorganisation,
            Kontaktverwaltung
          </h3>
          <p className="mb-8 text-gray-600">
            Wir verarbeiten Daten im Rahmen von Verwaltungsaufgaben sowie
            Organisation unseres Betriebs, Finanzbuchhaltung und Befolgung der
            gesetzlichen Pflichten, wie z.B. der Archivierung. Hierbei
            verarbeiten wir dieselben Daten, die wir im Rahmen der Erbringung
            unserer vertraglichen Leistungen verarbeiten. Die
            Verarbeitungsgrundlagen sind Art. 6 Abs. 1 lit. c. DSGVO, Art. 6
            Abs. 1 lit. f. DSGVO. Von der Verarbeitung sind Kunden,
            Interessenten, Geschäftspartner und Websitebesucher betroffen. Der
            Zweck und unser Interesse an der Verarbeitung liegt in der
            Administration, Finanzbuchhaltung, Büroorganisation, Archivierung
            von Daten, also Aufgaben die der Aufrechterhaltung unserer
            Geschäftstätigkeiten, Wahrnehmung unserer Aufgaben und Erbringung
            unserer Leistungen dienen. Die Löschung der Daten im Hinblick auf
            vertragliche Leistungen und die vertragliche Kommunikation
            entspricht den, bei diesen Verarbeitungstätigkeiten genannten
            Angaben.
          </p>
          <p className="mb-8 text-gray-600">
            Wir offenbaren oder übermitteln hierbei Daten an die
            Finanzverwaltung, Berater, wie z.B., Steuerberater oder
            Wirtschaftsprüfer sowie weitere Gebührenstellen und
            Zahlungsdienstleister.
          </p>
          <p className="mb-8 text-gray-600">
            Ferner speichern wir auf Grundlage unserer betriebswirtschaftlichen
            Interessen Angaben zu Lieferanten, Veranstaltern und sonstigen
            Geschäftspartnern, z.B. zwecks späterer Kontaktaufnahme. Diese
            mehrheitlich unternehmensbezogenen Daten, speichern wir
            grundsätzlich dauerhaft.
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Betriebswirtschaftliche Analysen und Marktforschung
          </h3>
          <p className="mb-8 text-gray-600">
            Um unser Geschäft wirtschaftlich betreiben, Markttendenzen, Wünsche
            der Vertragspartner und Nutzer erkennen zu können, analysieren wir
            die uns vorliegenden Daten zu Geschäftsvorgängen, Verträgen,
            Anfragen, etc. Wir verarbeiten dabei Bestandsdaten,
            Kommunikationsdaten, Vertragsdaten, Zahlungsdaten, Nutzungsdaten,
            Metadaten auf Grundlage des Art. 6 Abs. 1 lit. f. DSGVO, wobei zu
            den betroffenen Personen Vertragspartner, Interessenten, Kunden,
            Besucher und Nutzer unseres Onlineangebotes gehören.
          </p>
          <p className="mb-8 text-gray-600">
            Die Analysen erfolgen zum Zweck betriebswirtschaftlicher
            Auswertungen, des Marketings und der Marktforschung. Dabei können
            wir die Profile der registrierten Nutzer mit Angaben, z.B. zu deren
            in Anspruch genommenen Leistungen, berücksichtigen. Die Analysen
            dienen uns zur Steigerung der Nutzerfreundlichkeit, der Optimierung
            unseres Angebotes und der Betriebswirtschaftlichkeit. Die Analysen
            dienen alleine uns und werden nicht extern offenbart, sofern es sich
            nicht um anonyme Analysen mit zusammengefassten Werten handelt.
          </p>
          <p className="mb-8 text-gray-600">
            Sofern diese Analysen oder Profile personenbezogen sind, werden sie
            mit Kündigung der Nutzer gelöscht oder anonymisiert, sonst nach zwei
            Jahren ab Vertragsschluss. Im Übrigen werden die
            gesamtbetriebswirtschaftlichen Analysen und allgemeine
            Tendenzbestimmungen nach Möglichkeit anonym erstellt.
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Datenschutzhinweise im Bewerbungsverfahren
          </h3>
          <p className="mb-8 text-gray-600">
            Wir verarbeiten die Bewerberdaten nur zum Zweck und im Rahmen des
            Bewerbungsverfahrens im Einklang mit den gesetzlichen Vorgaben. Die
            Verarbeitung der Bewerberdaten erfolgt zur Erfüllung unserer
            (vor)vertraglichen Verpflichtungen im Rahmen des
            Bewerbungsverfahrens im Sinne des Art. 6 Abs. 1 lit. b. DSGVO Art. 6
            Abs. 1 lit. f. DSGVO sofern die Datenverarbeitung z.B. im Rahmen von
            rechtlichen Verfahren für uns erforderlich wird (in Deutschland gilt
            zusätzlich § 26 BDSG).
          </p>
          <p className="mb-8 text-gray-600">
            Das Bewerbungsverfahren setzt voraus, dass Bewerber uns die
            Bewerberdaten mitteilen. Die notwendigen Bewerberdaten sind, sofern
            wir ein Onlineformular anbieten gekennzeichnet, ergeben sich sonst
            aus den Stellenbeschreibungen und grundsätzlich gehören dazu die
            Angaben zur Person, Post- und Kontaktadressen und die zur Bewerbung
            gehörenden Unterlagen, wie Anschreiben, Lebenslauf und die
            Zeugnisse. Daneben können uns Bewerber freiwillig zusätzliche
            Informationen mitteilen.
          </p>
          <p className="mb-8 text-gray-600">
            Mit der Übermittlung der Bewerbung an uns, erklären sich die
            Bewerber mit der Verarbeitung ihrer Daten zu Zwecken des
            Bewerbungsverfahrens entsprechend der in dieser Datenschutzerklärung
            dargelegten Art und Umfang einverstanden.
          </p>
          <p className="mb-8 text-gray-600">
            Soweit im Rahmen des Bewerbungsverfahrens freiwillig besondere
            Kategorien von personenbezogenen Daten im Sinne des Art. 9 Abs. 1
            DSGVO mitgeteilt werden, erfolgt deren Verarbeitung zusätzlich nach
            Art. 9 Abs. 2 lit. b DSGVO (z.B. Gesundheitsdaten, wie z.B.
            Schwerbehinderteneigenschaft oder ethnische Herkunft). Soweit im
            Rahmen des Bewerbungsverfahrens besondere Kategorien von
            personenbezogenen Daten im Sinne des Art. 9 Abs. 1 DSGVO bei
            Bewerbern angefragt werden, erfolgt deren Verarbeitung zusätzlich
            nach Art. 9 Abs. 2 lit. a DSGVO (z.B. Gesundheitsdaten, wenn diese
            für die Berufsausübung erforderlich sind).
          </p>
          <p className="mb-8 text-gray-600">
            Sofern zur Verfügung gestellt, können uns Bewerber ihre Bewerbungen
            mittels eines Onlineformulars auf unserer Website übermitteln. Die
            Daten werden entsprechend dem Stand der Technik verschlüsselt an uns
            übertragen.
            <br />
            Ferner können Bewerber uns ihre Bewerbungen via E-Mail übermitteln.
            Hierbei bitten wir jedoch zu beachten, dass E-Mails grundsätzlich
            nicht verschlüsselt versendet werden und die Bewerber selbst für die
            Verschlüsselung sorgen müssen. Wir können daher für den
            Übertragungsweg der Bewerbung zwischen dem Absender und dem Empfang
            auf unserem Server keine Verantwortung übernehmen und empfehlen
            daher eher ein Online-Formular oder den postalischen Versand zu
            nutzen. Denn statt der Bewerbung über das Online-Formular und
            E-Mail, steht den Bewerbern weiterhin die Möglichkeit zur Verfügung,
            uns die Bewerbung auf dem Postweg zuzusenden.
          </p>
          <p className="mb-8 text-gray-600">
            Die von den Bewerbern zur Verfügung gestellten Daten, können im Fall
            einer erfolgreichen Bewerbung für die Zwecke des
            Beschäftigungsverhältnisses von uns weiterverarbeitet werden.
            Andernfalls, sofern die Bewerbung auf ein Stellenangebot nicht
            erfolgreich ist, werden die Daten der Bewerber gelöscht. Die Daten
            der Bewerber werden ebenfalls gelöscht, wenn eine Bewerbung
            zurückgezogen wird, wozu die Bewerber jederzeit berechtigt sind.
          </p>
          <p className="mb-8 text-gray-600">
            Die Löschung erfolgt, vorbehaltlich eines berechtigten Widerrufs der
            Bewerber, nach dem Ablauf eines Zeitraums von sechs Monaten, damit
            wir etwaige Anschlussfragen zu der Bewerbung beantworten und unseren
            Nachweispflichten aus dem Gleichbehandlungsgesetz genügen können.
            Rechnungen über etwaige Reisekostenerstattung werden entsprechend
            den steuerrechtlichen Vorgaben archiviert.
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Akismet Anti-Spam-Prüfung
          </h3>
          <p className="mb-8 text-gray-600">
            Unser Onlineangebot nutzt den Dienst „Akismet“, der von der
            Automattic Inc., 60 29th Street #343, San Francisco, CA 94110, USA,
            angeboten wird. Die Nutzung erfolgt auf Grundlage unserer
            berechtigten Interessen im Sinne des Art. 6 Abs. 1 lit. f) DSGVO.
            Mit Hilfe dieses Dienstes werden Kommentare echter Menschen von
            Spam-Kommentaren unterschieden. Dazu werden alle Kommentarangaben an
            einen Server in den USA verschickt, wo sie analysiert und für
            Vergleichszwecke vier Tage lang gespeichert werden. Ist ein
            Kommentar als Spam eingestuft worden, werden die Daten über diese
            Zeit hinaus gespeichert. Zu diesen Angaben gehören der eingegebene
            Name, die Emailadresse, die IP-Adresse, der Kommentarinhalt, der
            Referrer, Angaben zum verwendeten Browser sowie dem Computersystem
            und die Zeit des Eintrags.
          </p>
          <p className="mb-8 text-gray-600">
            Nähere Informationen zur Erhebung und Nutzung der Daten durch
            Akismet finden sich in den Datenschutzhinweisen von Automattic:{" "}
            <a
              className="text-yellow-500"
              href="https://automattic.com/privacy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://automattic.com/privacy/
            </a>
            .
          </p>
          <p className="mb-8 text-gray-600">
            Nutzer können gerne Pseudonyme nutzen, oder auf die Eingabe des
            Namens oder der Emailadresse verzichten. Sie können die Übertragung
            der Daten komplett verhindern, indem Sie unser Kommentarsystem nicht
            nutzen. Das wäre schade, aber leider sehen wir sonst keine
            Alternativen, die ebenso effektiv arbeiten.
          </p>
          <p className="mb-8 text-gray-600">&nbsp;</p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Abruf von Emojis und Smilies
          </h3>
          <p className="mb-8 text-gray-600">
            Innerhalb unseres WordPress-Blogs werden grafische Emojis (bzw.
            Smilies), d.h. kleine grafische Dateien, die Gefühle ausdrücken,
            eingesetzt, die von externen Servern bezogen werden. Hierbei erheben
            die Anbieter der Server, die IP-Adressen der Nutzer. Dies ist
            notwendig, damit die Emojie-Dateien an die Browser der Nutzer
            übermittelt werden können. Der Emojie-Service wird von der
            Automattic Inc., 60 29th Street #343, San Francisco, CA 94110, USA,
            angeboten. Datenschutzhinweise von Automattic:{" "}
            <a
              className="text-yellow-500"
              href="https://automattic.com/privacy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://automattic.com/privacy/
            </a>
            . Die verwendeten Server-Domains sind s.w.org und
            twemoji.maxcdn.com, wobei es sich unseres Wissens nach um sog.
            Content-Delivery-Networks handelt, also Server, die lediglich einer
            schnellen und sicheren Übermittlung der Dateien dienen und die
            personenbezogenen Daten der Nutzer nach der Übermittlung gelöscht
            werden.
          </p>
          <p className="mb-8 text-gray-600">
            Die Nutzung der Emojis erfolgt auf Grundlage unserer berechtigten
            Interessen, d.h. Interesse an einer attraktiven Gestaltung unseres
            Onlineangebotes gem. Art. 6 Abs. 1 lit. f. DSGVO.
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Kontaktaufnahme
          </h3>
          <p className="mb-8 text-gray-600">
            Bei der Kontaktaufnahme mit uns (z.B. per Kontaktformular, E-Mail,
            Telefon oder via sozialer Medien) werden die Angaben des Nutzers zur
            Bearbeitung der Kontaktanfrage und deren Abwicklung gem. Art. 6 Abs.
            1 lit. b) DSGVO verarbeitet. Die Angaben der Nutzer können in einem
            Customer-Relationship-Management System („CRM System“) oder
            vergleichbarer Anfragenorganisation gespeichert werden.
          </p>
          <p className="mb-8 text-gray-600">
            Wir löschen die Anfragen, sofern diese nicht mehr erforderlich sind.
            Wir überprüfen die Erforderlichkeit alle zwei Jahre; Ferner gelten
            die gesetzlichen Archivierungspflichten.
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Newsletter
          </h3>
          <p className="mb-8 text-gray-600">
            Mit den nachfolgenden Hinweisen informieren wir Sie über die Inhalte
            unseres Newsletters sowie das Anmelde-, Versand- und das
            statistische Auswertungsverfahren sowie Ihre Widerspruchsrechte auf.
            Indem Sie unseren Newsletter abonnieren, erklären Sie sich mit dem
            Empfang und den beschriebenen Verfahren einverstanden.
          </p>
          <p className="mb-8 text-gray-600">
            Inhalt des Newsletters: Wir versenden Newsletter, E-Mails und
            weitere elektronische Benachrichtigungen mit werblichen
            Informationen (nachfolgend „Newsletter“) nur mit der Einwilligung
            der Empfänger oder einer gesetzlichen Erlaubnis. Sofern im Rahmen
            einer Anmeldung zum Newsletter dessen Inhalte konkret umschrieben
            werden, sind sie für die Einwilligung der Nutzer maßgeblich. Im
            Übrigen enthalten unsere Newsletter Informationen zu unseren
            Produkten und sie begleitenden Informationen (z.B.
            Sicherheitshinweise), Angeboten, Aktionen und unser Unternehmen.
          </p>
          <p className="mb-8 text-gray-600">
            Double-Opt-In und Protokollierung: Die Anmeldung zu unserem
            Newsletter erfolgt in einem sog. Double-Opt-In-Verfahren. D.h. Sie
            erhalten nach der Anmeldung eine E-Mail, in der Sie um die
            Bestätigung Ihrer Anmeldung gebeten werden. Diese Bestätigung ist
            notwendig, damit sich niemand mit fremden E-Mailadressen anmelden
            kann. Die Anmeldungen zum Newsletter werden protokolliert, um den
            Anmeldeprozess entsprechend den rechtlichen Anforderungen nachweisen
            zu können. Hierzu gehört die Speicherung des Anmelde- und des
            Bestätigungszeitpunkts, als auch der IP-Adresse. Ebenso werden die
            Änderungen Ihrer bei dem Versanddienstleister gespeicherten Daten
            protokolliert.
          </p>
          <p className="mb-8 text-gray-600">
            Anmeldedaten: Um sich für den Newsletter anzumelden, reicht es aus,
            wenn Sie Ihre E-Mailadresse angeben. Optional bitten wir Sie einen
            Namen, zwecks persönlicher Ansprache im Newsletters anzugeben.
          </p>
          <p className="mb-8 text-gray-600">
            Der Versand des Newsletters und die mit ihm verbundene
            Erfolgsmessung erfolgen auf Grundlage einer Einwilligung der
            Empfänger gem. Art. 6 Abs. 1 lit. a, Art. 7 DSGVO i.V.m § 107 Abs. 2
            TKG oder falls eine Einwilligung nicht erforderlich ist, auf
            Grundlage unserer berechtigten Interessen am Direktmarketing gem.
            Art. 6 Abs. 1 lt. f. DSGVO i.V.m. § 107 Abs. 2 u. 3 TKG.
          </p>
          <p className="mb-8 text-gray-600">
            Die Protokollierung des Anmeldeverfahrens erfolgt auf Grundlage
            unserer berechtigten Interessen gem. Art. 6 Abs. 1 lit. f DSGVO.
            Unser Interesse richtet sich auf den Einsatz eines
            nutzerfreundlichen sowie sicheren Newslettersystems, das sowohl
            unseren geschäftlichen Interessen dient, als auch den Erwartungen
            der Nutzer entspricht und uns ferner den Nachweis von Einwilligungen
            erlaubt.
          </p>
          <p className="mb-8 text-gray-600">
            Kündigung/Widerruf – Sie können den Empfang unseres Newsletters
            jederzeit kündigen, d.h. Ihre Einwilligungen widerrufen. Einen Link
            zur Kündigung des Newsletters finden Sie am Ende eines jeden
            Newsletters. Wir können die ausgetragenen E-Mailadressen bis zu drei
            Jahren auf Grundlage unserer berechtigten Interessen speichern bevor
            wir sie löschen, um eine ehemals gegebene Einwilligung nachweisen zu
            können. Die Verarbeitung dieser Daten wird auf den Zweck einer
            möglichen Abwehr von Ansprüchen beschränkt. Ein individueller
            Löschungsantrag ist jederzeit möglich, sofern zugleich das ehemalige
            Bestehen einer Einwilligung bestätigt wird.
          </p>
          <p className="mb-8 text-gray-600">&nbsp;</p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Newsletter – Mailchimp
          </h3>
          <p className="mb-8 text-gray-600">
            Der Versand der Newsletter erfolgt mittels des Versanddienstleisters
            „MailChimp“, einer Newsletterversandplattform des US-Anbieters
            Rocket Science Group, LLC, 675 Ponce De Leon Ave NE #5000, Atlanta,
            GA 30308, USA. Die Datenschutzbestimmungen des Versanddienstleisters
            können Sie hier einsehen:{" "}
            <a
              className="text-yellow-500"
              href="https://mailchimp.com/legal/privacy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://mailchimp.com/legal/privacy/
            </a>
            . The Rocket Science Group LLC d/b/a MailChimp ist unter dem
            Privacy-Shield-Abkommen zertifiziert und bietet hierdurch eine
            Garantie, das europäisches Datenschutzniveau einzuhalten (
            <a
              className="text-yellow-500"
              href="https://www.privacyshield.gov/participant?id=a2zt0000000TO6hAAG&amp;status=Active"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.privacyshield.gov/participant?id=a2zt0000000TO6hAAG&amp;status=Active
            </a>
            ). Der Versanddienstleister wird auf Grundlage unserer berechtigten
            Interessen gem. Art. 6 Abs. 1 lit. f DSGVO und eines
            Auftragsverarbeitungsvertrages gem. Art. 28 Abs. 3 S. 1 DSGVO
            eingesetzt.
          </p>
          <p className="mb-8 text-gray-600">
            Der Versanddienstleister kann die Daten der Empfänger in pseudonymer
            Form, d.h. ohne Zuordnung zu einem Nutzer, zur Optimierung oder
            Verbesserung der eigenen Services nutzen, z.B. zur technischen
            Optimierung des Versandes und der Darstellung der Newsletter oder
            für statistische Zwecke verwenden. Der Versanddienstleister nutzt
            die Daten unserer Newsletterempfänger jedoch nicht, um diese selbst
            anzuschreiben oder um die Daten an Dritte weiterzugeben.
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Newsletter – Erfolgsmessung
          </h3>
          <p className="mb-8 text-gray-600">
            Die Newsletter enthalten einen sog. „web-beacon“, d.h. eine
            pixelgroße Datei, die beim Öffnen des Newsletters von unserem
            Server, bzw. sofern wir einen Versanddienstleister einsetzen, von
            dessen Server abgerufen wird. Im Rahmen dieses Abrufs werden
            zunächst technische Informationen, wie Informationen zum Browser und
            Ihrem System, als auch Ihre IP-Adresse und Zeitpunkt des Abrufs
            erhoben.
          </p>
          <p className="mb-8 text-gray-600">
            Diese Informationen werden zur technischen Verbesserung der Services
            anhand der technischen Daten oder der Zielgruppen und ihres
            Leseverhaltens anhand derer Abruforte (die mit Hilfe der IP-Adresse
            bestimmbar sind) oder der Zugriffszeiten genutzt. Zu den
            statistischen Erhebungen gehört ebenfalls die Feststellung, ob die
            Newsletter geöffnet werden, wann sie geöffnet werden und welche
            Links geklickt werden. Diese Informationen können aus technischen
            Gründen zwar den einzelnen Newsletterempfängern zugeordnet werden.
            Es ist jedoch weder unser Bestreben, noch, sofern eingesetzt, das
            des Versanddienstleisters, einzelne Nutzer zu beobachten. Die
            Auswertungen dienen uns viel mehr dazu, die Lesegewohnheiten unserer
            Nutzer zu erkennen und unsere Inhalte auf sie anzupassen oder
            unterschiedliche Inhalte entsprechend den Interessen unserer Nutzer
            zu versenden.
          </p>
          <p className="mb-8 text-gray-600">
            Ein getrennter Widerruf der Erfolgsmessung ist leider nicht möglich,
            in diesem Fall muss das gesamte Newsletterabonnement gekündigt
            werden.
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Hosting und E-Mail-Versand
          </h3>
          <p className="mb-8 text-gray-600">
            Die von uns in Anspruch genommenen Hosting-Leistungen dienen der
            Zurverfügungstellung der folgenden Leistungen: Infrastruktur- und
            Plattformdienstleistungen, Rechenkapazität, Speicherplatz und
            Datenbankdienste, E-Mail-Versand, Sicherheitsleistungen sowie
            technische Wartungsleistungen, die wir zum Zwecke des Betriebs
            dieses Onlineangebotes einsetzen.
          </p>
          <p className="mb-8 text-gray-600">
            Hierbei verarbeiten wir, bzw. unser Hostinganbieter Bestandsdaten,
            Kontaktdaten, Inhaltsdaten, Vertragsdaten, Nutzungsdaten, Meta- und
            Kommunikationsdaten von Kunden, Interessenten und Besuchern dieses
            Onlineangebotes auf Grundlage unserer berechtigten Interessen an
            einer effizienten und sicheren Zurverfügungstellung dieses
            Onlineangebotes gem. Art. 6 Abs. 1 lit. f DSGVO i.V.m. Art. 28 DSGVO
            (Abschluss Auftragsverarbeitungsvertrag).
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Erhebung von Zugriffsdaten und Logfiles
          </h3>
          <p className="mb-8 text-gray-600">
            Wir, bzw. unser Hostinganbieter, erhebt auf Grundlage unserer
            berechtigten Interessen im Sinne des Art. 6 Abs. 1 lit. f. DSGVO
            Daten über jeden Zugriff auf den Server, auf dem sich dieser Dienst
            befindet (sogenannte Serverlogfiles). Zu den Zugriffsdaten gehören
            Name der abgerufenen Webseite, Datei, Datum und Uhrzeit des Abrufs,
            übertragene Datenmenge, Meldung über erfolgreichen Abruf, Browsertyp
            nebst Version, das Betriebssystem des Nutzers, Referrer URL (die
            zuvor besuchte Seite), IP-Adresse und der anfragende Provider.
          </p>
          <p className="mb-8 text-gray-600">
            Logfile-Informationen werden aus Sicherheitsgründen (z.B. zur
            Aufklärung von Missbrauchs- oder Betrugshandlungen) für die Dauer
            von maximal 7 Tagen gespeichert und danach gelöscht. Daten, deren
            weitere Aufbewahrung zu Beweiszwecken erforderlich ist, sind bis zur
            endgültigen Klärung des jeweiligen Vorfalls von der Löschung
            ausgenommen.
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Google Tag Manager
          </h3>
          <p className="mb-8 text-gray-600">
            Google Tag Manager ist eine Lösung, mit der wir sog. Website-Tags
            über eine Oberfläche verwalten können (und so z.B. Google Analytics
            sowie andere Google-Marketing-Dienste in unser Onlineangebot
            einbinden). Der Tag Manager selbst (welches die Tags implementiert)
            verarbeitet keine personenbezogenen Daten der Nutzer. Im Hinblick
            auf die Verarbeitung der personenbezogenen Daten der Nutzer wird auf
            die folgenden Angaben zu den Google-Diensten verwiesen.
            Nutzungsrichtlinien:
            <a
              className="text-yellow-500"
              href="https://www.google.com/intl/de/tagmanager/use-policy.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.google.com/intl/de/tagmanager/use-policy.html
            </a>
            .<br />
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Google Analytics
          </h3>
          <p className="mb-8 text-gray-600">
            Wir setzen auf Grundlage unserer berechtigten Interessen (d.h.
            Interesse an der Analyse, Optimierung und wirtschaftlichem Betrieb
            unseres Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f. DSGVO)
            Google Analytics, einen Webanalysedienst der Google LLC („Google“)
            ein. Google verwendet Cookies. Die durch das Cookie erzeugten
            Informationen über Benutzung des Onlineangebotes durch die Nutzer
            werden in der Regel an einen Server von Google in den USA übertragen
            und dort gespeichert.
          </p>
          <p className="mb-8 text-gray-600">
            Google ist unter dem Privacy-Shield-Abkommen zertifiziert und bietet
            hierdurch eine Garantie, das europäische Datenschutzrecht
            einzuhalten (
            <a
              className="text-yellow-500"
              href="https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&amp;status=Active"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&amp;status=Active
            </a>
            ).
          </p>
          <p className="mb-8 text-gray-600">
            Google wird diese Informationen in unserem Auftrag benutzen, um die
            Nutzung unseres Onlineangebotes durch die Nutzer auszuwerten, um
            Reports über die Aktivitäten innerhalb dieses Onlineangebotes
            zusammenzustellen und um weitere, mit der Nutzung dieses
            Onlineangebotes und der Internetnutzung verbundene Dienstleistungen,
            uns gegenüber zu erbringen. Dabei können aus den verarbeiteten Daten
            pseudonyme Nutzungsprofile der Nutzer erstellt werden.
          </p>
          <p className="mb-8 text-gray-600">
            Wir setzen Google Analytics nur mit aktivierter IP-Anonymisierung
            ein. Das bedeutet, die IP-Adresse der Nutzer wird von Google
            innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen
            Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum
            gekürzt. Nur in Ausnahmefällen wird die volle IP-Adresse an einen
            Server von Google in den USA übertragen und dort gekürzt.
          </p>
          <p className="mb-8 text-gray-600">
            Die von dem Browser des Nutzers übermittelte IP-Adresse wird nicht
            mit anderen Daten von Google zusammengeführt. Die Nutzer können die
            Speicherung der Cookies durch eine entsprechende Einstellung ihrer
            Browser-Software verhindern; die Nutzer können darüber hinaus die
            Erfassung der durch das Cookie erzeugten und auf ihre Nutzung des
            Onlineangebotes bezogenen Daten an Google sowie die Verarbeitung
            dieser Daten durch Google verhindern, indem sie das unter folgendem
            Link verfügbare Browser-Plugin herunterladen und installieren:&nbsp;
            <a
              className="text-yellow-500"
              href="http://tools.google.com/dlpage/gaoptout?hl=de"
              target="_blank"
              rel="noopener noreferrer"
            >
              http://tools.google.com/dlpage/gaoptout?hl=de
            </a>
            .
          </p>
          <p className="mb-8 text-gray-600">
            Weitere Informationen zur Datennutzung durch Google, Einstellungs-
            und Widerspruchsmöglichkeiten, erfahren Sie in der
            Datenschutzerklärung von Google (
            <a
              className="text-yellow-500"
              href="https://policies.google.com/technologies/ads"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://policies.google.com/technologies/ads
            </a>
            ) sowie in den Einstellungen für die Darstellung von
            Werbeeinblendungen durch Google
            <a
              className="text-yellow-500"
              href="https://adssettings.google.com/authenticated"
              target="_blank"
              rel="noopener noreferrer"
            >
              (https://adssettings.google.com/authenticated
            </a>
            ).
          </p>
          <p className="mb-8 text-gray-600">
            Die personenbezogenen Daten der Nutzer werden nach 14 Monaten
            gelöscht oder anonymisiert.
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Google Universal Analytics
          </h3>
          <p className="mb-8 text-gray-600">
            Wir setzen Google Analytics in der Ausgestaltung als „
            <a
              className="text-yellow-500"
              href="https://support.google.com/analytics/answer/2790010?hl=de&amp;ref_topic=6010376"
              target="_blank"
              rel="noopener noreferrer"
            >
              Universal-Analytics
            </a>
            “ ein. „Universal Analytics“ bezeichnet ein Verfahren von Google
            Analytics, bei dem die Nutzeranalyse auf Grundlage einer pseudonymen
            Nutzer-ID erfolgt und damit ein pseudonymes Profil des Nutzers mit
            Informationen aus der Nutzung verschiedener Geräten erstellt wird
            (sog. „Cross-Device-Tracking“).
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Zielgruppenbildung mit Google Analytics
          </h3>
          <p className="mb-8 text-gray-600">
            Wir setzen Google Analytics ein, um die durch innerhalb von
            Werbediensten Googles und seiner Partner geschalteten Anzeigen, nur
            solchen Nutzern anzuzeigen, die auch ein Interesse an unserem
            Onlineangebot gezeigt haben oder die bestimmte Merkmale (z.B.
            Interessen an bestimmten Themen oder Produkten, die anhand der
            besuchten Webseiten bestimmt werden) aufweisen, die wir an Google
            übermitteln (sog. „Remarketing-“, bzw.
            „Google-Analytics-Audiences“). Mit Hilfe der Remarketing Audiences
            möchten wir auch sicherstellen, dass unsere Anzeigen dem
            potentiellen Interesse der Nutzer entsprechen.
            <br />
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Visual Website Optimizer
          </h3>
          <p className="mb-8 text-gray-600">
            Innerhalb unseres Onlineangebotes wird auf Grundlage unserer
            berechtigten Interessen (d.h. Interesse an der Analyse, Optimierung
            und wirtschaftlichem Betrieb unseres Onlineangebotes im Sinne des
            Art. 6 Abs. 1 lit. f. DSGVO) der Dienst Visual Website Optimizer
            (ein Angebot der Wingify Software Private Limited, 404, Gopal
            Heights, Netaji Subhash Place, Pitam Pura, Delhi 110034, India)
            eingesetzt.
          </p>
          <p className="mb-8 text-gray-600">
            Visual Website Optimizer erlaubt im Rahmen so genannten
            „A/B-Testings“, „Clicktracking“ und „Heatmaps“ nachzuvollziehen, wie
            sich verschiedene Änderungen einer Website auswirken (z.B.
            Veränderungen der Eingabefelder, des Designs, etc.). A/B Tests
            dienen der Verbesserung der Benutzerfreundlichkeit und Performance
            von Onlineangeboten. Dabei werden Nutzer z.B. unterschiedliche
            Versionen einer Website oder ihrer Elemente, wie Eingabeformulare,
            dargestellt, auf denen sich die Platzierung der Inhalte oder
            Beschriftungen der Navigationselemente unterscheiden können.
            Anschließend kann anhand des Verhaltens der Nutzer, z.B. längeres
            Verweilen auf der Webseite oder häufigerer Interaktion mit den
            Elementen, feststellt werden welche dieser Webseiten oder Elemente
            eher den Bedürfnissen der Nutzer entsprechen. „Clicktracking“
            erlaubt es die Bewegungen der Nutzer innerhalb eines gesamten
            Onlineangebotes zu überblicken. Da die Ergebnisse dieser Tests
            genauer sind, wenn die Interaktion der Nutzer über einen gewissen
            Zeitraum verfolgt werden kann (z.B. schauen können, ob ein Nutzer
            gerne wiederkehrt), werden für diese Test-Zwecke im Regelfall
            Cookies auf den Rechnern der Nutzer gespeichert. „Heatmaps“ sind
            Mausbewegungen der Nutzer, die zu einem Gesamtbild zusammengefasst
            werden, mit dessen Hilfe z.B. erkannt werden kann, welche
            Webseitenelemente bevorzugt angesteuert werden und welche
            Webseitenelemente Nutzer weniger bevorzugen.
          </p>
          <p className="mb-8 text-gray-600">
            Nur für diese Testzwecke werden Cookies auf den Geräten der Nutzer
            abgelegt. Dabei werden nur pseudonyme Daten der Nutzer verarbeitet.
            Für weitere Informationen verweisen wir auf die Datenschutzerklärung
            von Visual Website Optimizer:
            <a
              className="text-yellow-500"
              href="https://vwo.com/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://vwo.com/privacy-policy/
            </a>
            .
          </p>
          <p className="mb-8 text-gray-600">
            Falls Sie nicht möchten, dass der Visual Website Optimizer Ihr
            Nutzungsverhalten erfasst, können sie mit Hilfe dieses Links der
            Datenerfassung widersprechen:
            <a
              className="text-yellow-500"
              href="https://www.gets.by/?vwo_opt_out=1"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.gets.by/?vwo_opt_out=1
            </a>
            .
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Onlinepräsenzen in sozialen Medien
          </h3>
          <p className="mb-8 text-gray-600">
            Wir unterhalten Onlinepräsenzen innerhalb sozialer Netzwerke und
            Plattformen, um mit den dort aktiven Kunden, Interessenten und
            Nutzern kommunizieren und sie dort über unsere Leistungen
            informieren zu können. Beim Aufruf der jeweiligen Netzwerke und
            Plattformen gelten die Geschäftsbedingungen und die
            Datenverarbeitungsrichtlinien deren jeweiligen Betreiber.
          </p>
          <p className="mb-8 text-gray-600">
            Soweit nicht anders im Rahmen unserer Datenschutzerklärung
            angegeben, verarbeiten wir die Daten der Nutzer sofern diese mit uns
            innerhalb der sozialen Netzwerke und Plattformen kommunizieren, z.B.
            Beiträge auf unseren Onlinepräsenzen verfassen oder uns Nachrichten
            zusenden.
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Einbindung von Diensten und Inhalten Dritter
          </h3>
          <p className="mb-8 text-gray-600">
            Wir setzen innerhalb unseres Onlineangebotes auf Grundlage unserer
            berechtigten Interessen (d.h. Interesse an der Analyse, Optimierung
            und wirtschaftlichem Betrieb unseres Onlineangebotes im Sinne des
            Art. 6 Abs. 1 lit. f. DSGVO) Inhalts- oder Serviceangebote von
            Drittanbietern ein, um deren Inhalte und Services, wie z.B. Videos
            oder Schriftarten einzubinden (nachfolgend einheitlich bezeichnet
            als “Inhalte”).
          </p>
          <p className="mb-8 text-gray-600">
            Dies setzt immer voraus, dass die Drittanbieter dieser Inhalte, die
            IP-Adresse der Nutzer wahrnehmen, da sie ohne die IP-Adresse die
            Inhalte nicht an deren Browser senden könnten. Die IP-Adresse ist
            damit für die Darstellung dieser Inhalte erforderlich. Wir bemühen
            uns nur solche Inhalte zu verwenden, deren jeweilige Anbieter die
            IP-Adresse lediglich zur Auslieferung der Inhalte verwenden.
            Drittanbieter können ferner so genannte Pixel-Tags (unsichtbare
            Grafiken, auch als „Web Beacons“ bezeichnet) für statistische oder
            Marketingzwecke verwenden. Durch die „Pixel-Tags“ können
            Informationen, wie der Besucherverkehr auf den Seiten dieser Website
            ausgewertet werden. Die pseudonymen Informationen können ferner in
            Cookies auf dem Gerät der Nutzer gespeichert werden und unter
            anderem technische Informationen zum Browser und Betriebssystem,
            verweisende Webseiten, Besuchszeit sowie weitere Angaben zur Nutzung
            unseres Onlineangebotes enthalten, als auch mit solchen
            Informationen aus anderen Quellen verbunden werden.
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Google Fonts
          </h3>
          <p className="mb-8 text-gray-600">
            Wir binden die Schriftarten („Google Fonts“) des Anbieters Google
            LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA, ein.
            Datenschutzerklärung:
            <a
              className="text-yellow-500"
              href="https://www.google.com/policies/privacy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.google.com/policies/privacy/
            </a>
            , Opt-Out:
            <a
              className="text-yellow-500"
              href="https://adssettings.google.com/authenticated"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://adssettings.google.com/authenticated
            </a>
            .
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Google ReCaptcha
          </h3>
          <p className="mb-8 text-gray-600">
            Wir binden die Funktion zur Erkennung von Bots, z.B. bei Eingaben in
            Onlineformularen („ReCaptcha“) des Anbieters Google LLC, 1600
            Amphitheatre Parkway, Mountain View, CA 94043, USA, ein.
            Datenschutzerklärung:
            <a
              className="text-yellow-500"
              href="https://www.google.com/policies/privacy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.google.com/policies/privacy/
            </a>
            , Opt-Out:
            <a
              className="text-yellow-500"
              href="https://adssettings.google.com/authenticated"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://adssettings.google.com/authenticated
            </a>
            .
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Google Maps
          </h3>
          <p className="mb-8 text-gray-600">
            Wir binden die Landkarten des Dienstes “Google Maps” des Anbieters
            Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA,
            ein. Zu den verarbeiteten Daten können insbesondere IP-Adressen und
            Standortdaten der Nutzer gehören, die jedoch nicht ohne deren
            Einwilligung (im Regelfall im Rahmen der Einstellungen ihrer
            Mobilgeräte vollzogen), erhoben werden. Die Daten können in den USA
            verarbeitet werden. Datenschutzerklärung:
            <a
              className="text-yellow-500"
              href="https://www.google.com/policies/privacy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.google.com/policies/privacy/
            </a>
            , Opt-Out:
            <a
              className="text-yellow-500"
              href="https://adssettings.google.com/authenticated"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://adssettings.google.com/authenticated
            </a>
            .
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Verwendung von Facebook Social Plugins
          </h3>
          <p className="mb-8 text-gray-600">
            Wir nutzen auf Grundlage unserer berechtigten Interessen (d.h.
            Interesse an der Analyse, Optimierung und wirtschaftlichem Betrieb
            unseres Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f. DSGVO)
            Social Plugins („Plugins“) des sozialen Netzwerkes facebook.com,
            welches von der Facebook Ireland Ltd., 4 Grand Canal Square, Grand
            Canal Harbour, Dublin 2, Irland betrieben wird („Facebook“). Die
            Plugins können Interaktionselemente oder Inhalte (z.B. Videos,
            Grafiken oder Textbeiträge) darstellen und sind an einem der
            Facebook Logos erkennbar (weißes „f“ auf blauer Kachel, den
            Begriffen „Like“, „Gefällt mir“ oder einem „Daumen hoch“-Zeichen)
            oder sind mit dem Zusatz „Facebook Social Plugin“ gekennzeichnet.
            Die Liste und das Aussehen der Facebook Social Plugins kann hier
            eingesehen werden:&nbsp;
            <a
              className="text-yellow-500"
              href="https://developers.facebook.com/docs/plugins/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://developers.facebook.com/docs/plugins/
            </a>
            .
          </p>
          <p className="mb-8 text-gray-600">
            Facebook ist unter dem Privacy-Shield-Abkommen zertifiziert und
            bietet hierdurch eine Garantie, das europäische Datenschutzrecht
            einzuhalten (
            <a
              className="text-yellow-500"
              href="https://www.privacyshield.gov/participant?id=a2zt0000000GnywAAC&amp;status=Active"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.privacyshield.gov/participant?id=a2zt0000000GnywAAC&amp;status=Active
            </a>
            ).
          </p>
          <p className="mb-8 text-gray-600">
            Wenn ein Nutzer eine Funktion dieses Onlineangebotes aufruft, die
            ein solches Plugin enthält, baut sein Gerät eine direkte Verbindung
            mit den Servern von Facebook auf. Der Inhalt des Plugins wird von
            Facebook direkt an das Gerät des Nutzers übermittelt und von diesem
            in das Onlineangebot eingebunden. Dabei können aus den verarbeiteten
            Daten Nutzungsprofile der Nutzer erstellt werden. Wir haben daher
            keinen Einfluss auf den Umfang der Daten, die Facebook mit Hilfe
            dieses Plugins erhebt und informiert die Nutzer daher entsprechend
            unserem Kenntnisstand.
          </p>
          <p className="mb-8 text-gray-600">
            Durch die Einbindung der Plugins erhält Facebook die Information,
            dass ein Nutzer die entsprechende Seite des Onlineangebotes
            aufgerufen hat. Ist der Nutzer bei Facebook eingeloggt, kann
            Facebook den Besuch seinem Facebook-Konto zuordnen. Wenn Nutzer mit
            den Plugins interagieren, zum Beispiel den Like Button betätigen
            oder einen Kommentar abgeben, wird die entsprechende Information von
            Ihrem Gerät direkt an Facebook übermittelt und dort gespeichert.
            Falls ein Nutzer kein Mitglied von Facebook ist, besteht trotzdem
            die Möglichkeit, dass Facebook seine IP-Adresse in Erfahrung bringt
            und speichert. Laut Facebook wird in Deutschland nur eine
            anonymisierte IP-Adresse gespeichert.
          </p>
          <p className="mb-8 text-gray-600">
            Zweck und Umfang der Datenerhebung und die weitere Verarbeitung und
            Nutzung der Daten durch Facebook sowie die diesbezüglichen Rechte
            und Einstellungsmöglichkeiten zum Schutz der Privatsphäre der
            Nutzer, können diese den Datenschutzhinweisen von Facebook
            entnehmen:&nbsp;
            <a
              className="text-yellow-500"
              href="https://www.facebook.com/about/privacy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.facebook.com/about/privacy/
            </a>
            .
          </p>
          <p className="mb-8 text-gray-600">
            Wenn ein Nutzer Facebookmitglied ist und nicht möchte, dass Facebook
            über dieses Onlineangebot Daten über ihn sammelt und mit seinen bei
            Facebook gespeicherten Mitgliedsdaten verknüpft, muss er sich vor
            der Nutzung unseres Onlineangebotes bei Facebook ausloggen und seine
            Cookies löschen. Weitere Einstellungen und Widersprüche zur Nutzung
            von Daten für Werbezwecke, sind innerhalb der
            Facebook-Profileinstellungen möglich:&nbsp;
            <a
              className="text-yellow-500"
              href="https://www.facebook.com/settings?tab=ads"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.facebook.com/settings?tab=ads
            </a>
            &nbsp;oder über die US-amerikanische Seite&nbsp;
            <a
              className="text-yellow-500"
              href="http://www.aboutads.info/choices/"
              target="_blank"
              rel="noopener noreferrer"
            >
              http://www.aboutads.info/choices/
            </a>
            &nbsp;oder die EU-Seite&nbsp;
            <a
              className="text-yellow-500"
              href="http://www.youronlinechoices.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              http://www.youronlinechoices.com/
            </a>
            . Die Einstellungen erfolgen plattformunabhängig, d.h. sie werden
            für alle Geräte, wie Desktopcomputer oder mobile Geräte übernommen.
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Twitter
          </h3>
          <p className="mb-8 text-gray-600">
            Innerhalb unseres Onlineangebotes können Funktionen und Inhalte des
            Dienstes Twitter, angeboten durch die Twitter Inc., 1355 Market
            Street, Suite 900, San Francisco, CA 94103, USA, eingebunden werden.
            Hierzu können z.B. Inhalte wie Bilder, Videos oder Texte und
            Schaltflächen gehören, mit denen Nutzer Inhalte dieses
            Onlineangebotes innerhalb von Twitter teilen können.
            <br />
            Sofern die Nutzer Mitglieder der Plattform Twitter sind, kann
            Twitter den Aufruf der o.g. Inhalte und Funktionen den dortigen
            Profilen der Nutzer zuordnen. Twitter ist unter dem
            Privacy-Shield-Abkommen zertifiziert und bietet hierdurch eine
            Garantie, das europäische Datenschutzrecht einzuhalten (
            <a
              className="text-yellow-500"
              href="https://www.privacyshield.gov/participant?id=a2zt0000000TORzAAO&amp;status=Active"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.privacyshield.gov/participant?id=a2zt0000000TORzAAO&amp;status=Active
            </a>
            ). Datenschutzerklärung:
            <a
              className="text-yellow-500"
              href="https://twitter.com/de/privacy"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://twitter.com/de/privacy
            </a>
            , Opt-Out:
            <a
              className="text-yellow-500"
              href="https://twitter.com/personalization"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://twitter.com/personalization
            </a>
            .
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Instagram
          </h3>
          <p className="mb-8 text-gray-600">
            Innerhalb unseres Onlineangebotes können Funktionen und Inhalte des
            Dienstes Instagram, angeboten durch die Instagram Inc., 1601 Willow
            Road, Menlo Park, CA, 94025, USA, eingebunden werden. Hierzu können
            z.B. Inhalte wie Bilder, Videos oder Texte und Schaltflächen
            gehören, mit denen Nutzer Inhalte dieses Onlineangebotes innerhalb
            von Instagram teilen können. Sofern die Nutzer Mitglieder der
            Plattform Instagram sind, kann Instagram den Aufruf der o.g. Inhalte
            und Funktionen den dortigen Profilen der Nutzer zuordnen.
            Datenschutzerklärung von Instagram:
            <a
              className="text-yellow-500"
              href="http://instagram.com/about/legal/privacy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              http://instagram.com/about/legal/privacy/
            </a>
            .
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Pinterest
          </h3>
          <p className="mb-8 text-gray-600">
            Innerhalb unseres Onlineangebotes können Funktionen und Inhalte des
            Dienstes Pinterest, angeboten durch die Pinterest Inc., 635 High
            Street, Palo Alto, CA, 94301, USA, eingebunden werden. Hierzu können
            z.B. Inhalte wie Bilder, Videos oder Texte und Schaltflächen
            gehören, mit denen Nutzer Inhalte dieses Onlineangebotes innerhalb
            von Pinterest teilen können. Sofern die Nutzer Mitglieder der
            Plattform Pinterest sind, kann Pinterest den Aufruf der o.g. Inhalte
            und Funktionen den dortigen Profilen der Nutzer zuordnen.
            Datenschutzerklärung von Pinterest:
            <a
              className="text-yellow-500"
              href="https://about.pinterest.com/de/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://about.pinterest.com/de/privacy-policy
            </a>
            .
          </p>
          <p className="mb-8 text-gray-600">
            <a
              className="text-yellow-500"
              href="https://datenschutz-generator.de"
              target="_blank"
              rel="noopener noreferrer"
            >
              Erstellt mit Datenschutz-Generator.de von RA Dr. Thomas Schwenke
            </a>
          </p>
        </div>
      </section>

      <WavesBottom />
    </Layout>
  );
};

export default PrivacyPolicyPage;
